// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      // postage:'',
      // opaque:'',
    };
  },
  created() {
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 500);
  },
  computed: {
    websiteinfo() {
      return this.$store.state.bak.personalInfo;
    },
    // postage(){
    //   return this.$store.state.waterInfo.addto;
    // }
  },
  methods: {
    // 图片上传回调钩子方法
    handleSuccess(response) {
      checkRule(response, this); // 检查是否有权限
      if (response.code == 1) {
        this.websiteinfo.img = response.imgpath;
        this.$Message.success('图片上传成功');
      } else {
        this.$Message.error('图片上传失败');
      }
    },

    // vue的ajax
    webSitePutData() {
      const self = this;
      axios({
        method: 'post',
        url: '/admin/Website/personalUpdate',
        data: qs.stringify({
          username: this.websiteinfo.username,
          white: this.websiteinfo.white,
          email: this.websiteinfo.email,
          position: this.websiteinfo.position,
          img: this.websiteinfo.img,
        }),
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            self.$Message.success(response.data.msg);
          } else if (
            response.data.code != 1 &&
            response.data.code != undefined
          ) {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {});
    },
  },
};
